import {
    Component,
    EventEmitter,
    Input,
    Output,
    SimpleChanges,
    TemplateRef,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { PopoverDirective, PopoverPlacement } from 'ngx-smart-popover';

/**
 * @group Basic Toolkit
 * @component Toggle Dropdown
 *
 * @export
 * @class LsqToggleDropdownComponent
 */
@Component({
    selector: 'lsq-toggle-dropdown',
    template: `
        <div
            class="toggle-wrapper"
            [popover]="dropdownPanelRef"
            [popoverOnHover]="false"
            [popoverPlacement]="popoverPlacement"
            (onShown)="open.emit()"
            (onHidden)="close.emit()"
        >
            <ng-container *ngTemplateOutlet="toggleTemplateRef"></ng-container>
        </div>
        <popover-content
            #dropdownPanelRef
            [closeOnClickOutside]="true"
            [ngClass]="{ 'hide-caret': !showCaret }"
        >
            <ng-content></ng-content>
        </popover-content>
    `,
    styleUrls: ['./lsq-toggle-dropdown.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LsqToggleDropdownComponent {
    @Input() public showCaret = true;
    @Input() public toggleTemplateRef: TemplateRef<any>;
    @Input() public direction: 'left' | 'right' | 'center' = 'center';
    @Output() public open = new EventEmitter();
    @Output() public close = new EventEmitter();
    @ViewChild(PopoverDirective) public popover: PopoverDirective;
    public popoverPlacement: PopoverPlacement = PopoverPlacement.Bottom;

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.direction) {
            this.popoverPlacement = PopoverPlacement.Bottom;
            if (this.direction === 'left') {
                this.popoverPlacement = PopoverPlacement.BottomLeft;
            } else if (this.direction === 'right') {
                this.popoverPlacement = PopoverPlacement.BottomRight;
            }
        }
    }

    public openDropdown(): void {
        this.popover.show();
    }

    public closeDropdown(): void {
        this.popover.hide();
    }
}
